
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informations",
      function () {
        return require("private-next-pages/informations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informations"])
      });
    }
  